<template>
	<DiscoveryTableSingleComponents />
</template>

<script>
import DiscoveryTableSingleComponents from './DiscoveryTableSingleComponents/DiscoveryTableSingleComponents'

export default {
	name: "DiscoveryTableSingleNew",
	components: {
		DiscoveryTableSingleComponents
	}
}
</script>

<style scoped>

</style>